import { render, staticRenderFns } from "./KerryDropoff_V2.vue?vue&type=template&id=54fdc213&"
import script from "./KerryDropoff_V2.vue?vue&type=script&lang=js&"
export * from "./KerryDropoff_V2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports